import { createRemoteStore } from '@move-frontend/utils';
import { PutVehicleRequest } from '../../../../shared/api/gateway/types/vehicle';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';
import { ILoaderEditVehicle } from '../use-cases/editVehicleLoader';

export type EditVehicleStore = ReturnType<typeof createEditVehicleStore>;

export const createEditVehicleStore = (editVehicleLoader: ILoaderEditVehicle) =>
	createRemoteStore<PutVehicleRequest, IVehicle>({
		loader: editVehicleLoader,
	});
